<template>
  <b-card no-body :header="title" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
  <b-list-group flush>
    <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index"  ><img class="redS" :src="require('../assets/ui/red.png')">  {{ item.result }}</b-list-group-item>
  </b-list-group>
  </b-card>
</template>
<script>

export default {
  name: 'PresonalCard',
  props: {
    listdata:Array,
    title:String
  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
